import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../client";

// Helper function to create API call async thunks
const createApiThunk = (name, url, hasParam = false) =>
  createAsyncThunk(name, async (param, thunkAPI) => {
    const finalUrl = hasParam ? url(param) : url;
    const response = await api.get(finalUrl);
    return response.data;
  });

// Export async thunks
export const fetchFormElements = createApiThunk(
  "PageComponents",
  "shared/FormElements/by-application/fixilo",
);

export const fetchRegisterForm = createApiThunk(
  "RegisterComponent",
  "shared/FormElements/by-name/fixilo/Register",
);

export const fetchScreens = createApiThunk("Screens", "shared/Screens");

export const getStates = createApiThunk("States", "Common/States");

export const getDistricts = createApiThunk("Districts", "Common/Districts");

export const getDistrictsByState = createApiThunk(
  "DistrictsByState",
  (id) => `Common/Districts/${id}`,
  true,
);

export const fetchWorkCategories = createApiThunk(
  "WorkCategories",
  "shared/WorkCategories",
);

const initialState = {
  pages: null,
  page: null,
  screens: null,
  districts: null,
  states: null,
  workCategories: null,
  failedMessage: null,
  isLoading: false,
};

// Helper function to handle async thunk states
const createAsyncHandler = (state, action, stateKey) => {
  if (stateKey) {
    state[stateKey] = action.payload?.data;
  }
};

const slice = createSlice({
  name: "common",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Generic handler for thunks with simple payload
    const simpleThunks = [
      { thunk: fetchFormElements, stateKey: "pages" },
      { thunk: fetchScreens, stateKey: "screens" },
    ];

    // Generic handler for thunks with data extraction
    const dataThunks = [
      { thunk: fetchRegisterForm, stateKey: "page" },
      { thunk: getStates, stateKey: "states" },
      { thunk: getDistricts, stateKey: "districts" },
      { thunk: getDistrictsByState, stateKey: "districts" },
      { thunk: fetchWorkCategories, stateKey: "workCategories" },
    ];

    // Add simple fulfilled cases
    simpleThunks.forEach(({ thunk, stateKey }) => {
      builder.addCase(thunk.fulfilled, (state, action) => {
        createAsyncHandler(state, action, stateKey);
      });
      builder.addCase(thunk.rejected, (state, action) => {
        state.failedMessage = action.payload;
      });
    });

    // Add complex thunks with pending state
    dataThunks.forEach(({ thunk, stateKey }) => {
      builder.addCase(thunk.pending, (state) => {
        state.isLoading = true;
      });
      builder.addCase(thunk.fulfilled, (state, action) => {
        state.isLoading = false;
        createAsyncHandler(state, action, stateKey);
      });
      builder.addCase(thunk.rejected, (state, action) => {
        state.isLoading = false;
        state.failedMessage = action.payload;
      });
    });
  },
});

export default slice.reducer;
